import _debounce from 'lodash/debounce';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Breadcrumb from 'components/_parts/atoms/breadcrumb';
import Button from 'components/_parts/atoms/button';
import ContainerPage from 'components/_parts/atoms/containerPage';
import IconCustom from 'components/_parts/atoms/icon';
import Input from 'components/_parts/atoms/input';
import Label from 'components/_parts/atoms/label';
import Tab from 'components/_parts/atoms/tab';
import CustomTable from 'components/_parts/atoms/table';
import TextArea from 'components/_parts/atoms/textArea';
import TextEditor from 'components/_parts/atoms/textEditor';
import ButtonCreate from 'components/_parts/molecules/Button/Create';
import InputSearch from 'components/_parts/molecules/Search';
import List from 'components/_parts/molecules/list/listBp';
import ListCvc from 'components/_parts/molecules/list/listCvc';
import ModalCreate from 'components/_parts/molecules/modal/business_process';
import { HIT_STRUCTURE } from 'redux/actions/organization';
import TextAreaAutoResizeCustom from 'pages/workloadAssessment/landing/revamp/FieldTextArea';
import Window from '../molecules/popUpWindow';

const datasCreate = [
  {
    id: 1,
    name: 'Add Primary Process',
    icon: 'plus',
  },
  {
    id: 2,
    name: 'Add Steering Gov.',
    icon: 'plus',
  },
  {
    id: 3,
    name: 'Add Support Process',
    icon: 'plus',
  },
];
const datasCreateChild = [
  {
    name: 'Add Next',
    icon: 'rightDown',
  },
  {
    name: 'Add Previous',
    icon: 'leftUp',
  },
];
const datasOption = [
  {
    name: 'Edit',
    icon: 'edit',
    color: '#2E9CFF',
  },
];
const datasExport = [
  {
    name: 'Export',
    icon: 'edit',
    color: '#2E9CFF',
  },
];

const dataLastItem = {
  id: 4,
  name: 'Add From Library',
  icon: 'box',
};
const dataLastItemChild = {
  name: 'Add Child',
  icon: 'plusSquare',
};
const dataLastItemOpotion = {
  name: 'Delete',
  icon: 'box',
};
const dataLastItemExport = {
  name: 'Import',
  icon: 'box',
};

const dataSearch = [
  {
    id: 1,
    label: 'Procurement Activities',
    type: 'primary',
  },
  {
    id: 2,
    label: 'Procurement Activities2',
    type: 'steering',
  },
  {
    id: 3,
    label: 'Procurement Activities3',
    type: 'support',
  },
  {
    id: 4,
    label: 'Procurement Activities4',
    type: 'primary',
  },
  {
    id: 5,
    label: 'Procurement Activities4',
    type: 'primary',
  },
  {
    id: 6,
    label: 'Procurement Activities4',
    type: 'primary',
  },
  {
    id: 7,
    label: 'Procurement Activities4',
    type: 'primary',
  },
];

const dataListDelete = [
  {
    id: 1,
    title: 'Set A - Drilling Skill - Expert',
  },
  {
    id: 2,
    title: 'Set A - Drilling Skill - Expert',
  },
  {
    id: 3,
    title: 'Set A - Drilling Skill - Expert',
  },
];
const dataListCreate = [
  {
    id: 1,
    title: 'Procurement Activities',
    type: 'primary',
  },
  {
    id: 2,
    title: 'Procurement Activities2',
    type: 'primary',
  },
  {
    id: 3,
    title: 'Procurement Activities3',
    type: 'primary',
  },
];

const datalListCvc = [
  {
    id: 1,
    title: 'Procurement Activities',
    type: 'primary',
  },
  {
    id: 4,
    title: 'Procurement Activities4',
    type: 'primary',
  },
  {
    id: 5,
    title: 'Procurement Activities4',
    type: 'primary',
  },
  {
    id: 2,
    title: 'Procurement Activities2',
    type: 'steering',
  },
  {
    id: 3,
    title: 'Procurement Activities3',
    type: 'support',
  },
];

const dataTable = [
  {
    hierarcy: '1.0',
    title: 'AdHoc',
    category: 'primary',
  },
  {
    hierarcy: '1.0.1',
    title: 'AdHoc',
    category: 'primary',
  },
  {
    hierarcy: '1.0.1.1',
    title: 'AdHoc',
    category: 'steering',
  },
  {
    hierarcy: '1.0.1.1.1',
    title: 'AdHoc',
    category: 'steering',
  },
  {
    hierarcy: '1.0.1.1.1.1',
    title: 'AdHoc',
    category: 'support',
  },
];

function TestPage() {
  const dispatch = useDispatch();
  const [isCheck, setIsCheck] = useState(true);
  const [modal, setModal] = useState(false);
  const [typeModal, setTypeModal] = useState(false);
  const [value, setValue] = useState('');
  const [choose, setChoose] = useState('');
  const [valueStructure, setValueStructure] = useState('');
  const [dataFilter, setDataFilter] = useState([]);
  const [textArea, setTextArea] = useState('');

  const { listStructure } = useSelector((state) => ({
    listStructure: state?.organization?.structure?.map((value, index) => ({
      value: value.organization_id || '-',
      label: value.name || '-',
    })),
  }));

  useEffect(() => {
    const payload = {
      board_id: '163b9806-0d06-47b4-a3a9-27e88e03f15f',
    };

    dispatch({
      type: HIT_STRUCTURE,
      payload,
    });
  }, [dispatch]);

  const handleCheckbox = () => {
    isCheck ? setIsCheck(false) : setIsCheck(true);
  };

  const columns = [
    {
      name: 'Hierarcy',
      width: '14%',
      selector: (row) => (
        <div className="d-flex align-items-center">
          <Button
            style={{
              width: '28px',
              height: '28px',
              backgroundColor: 'transparent',
              color: '#3D5AFE',
            }}
          >
            <IconCustom typeIcon="minus" style={{ color: '#FF0000' }} />
          </Button>
          <Button
            style={{
              width: '30px',
              height: '28px',
              backgroundColor: 'transparent',
              color: '#3D5AFE',
            }}
          >
            <IconCustom typeIcon="menu" style={{ color: '#D1D1D1' }} />
          </Button>
          <Label
            style={{
              fontSize: '12px',
              fontWeight: '700',
              color: '#4C4C4C',
            }}
          >
            {row.hierarcy}
          </Label>
        </div>
      ),
    },
    {
      name: 'Title',
      width: '28%',
      style: {
        display: 'flex',
        justifyContent: 'flex-start',
      },
      selector: (row) => row.title,
    },
    {
      name: 'Category',
      width: '10%',
      center: true,
      selector: (row) => (
        <Button
          style={{
            backgroundColor:
              row.category === 'primary'
                ? '#2E9CFF'
                : row.category === 'steering'
                  ? '#79FF39'
                  : '#FFDF32',
            height: '20px',
            padding: '0px 20px',
            fontWeight: '600',
            marginLeft: 'auto',
          }}
        >
          {row.category}
        </Button>
      ),
    },
    {
      name: 'Leading Indicator',
      width: '8%',
      style: {
        // padding: "0"
      },
      center: true,
      selector: (row) => (
        <Input
          type="checkbox"
          name="input_checkbox"
          checked={isCheck}
          onChange={handleCheckbox}
          typeCheckbox="success"
        />
      ),
    },
    {
      name: 'Technincal Competency',
      center: true,
      width: '10%',
      selector: (row) => (
        <Input
          type="checkbox"
          name="input_checkbox"
          checked={isCheck}
          onChange={handleCheckbox}
          typeCheckbox="error"
        />
      ),
    },
    {
      name: 'Behaviour Competency',
      center: true,
      width: '10%',
      selector: (row) => (
        <Input
          type="checkbox"
          name="input_checkbox"
          checked={isCheck}
          onChange={handleCheckbox}
          typeCheckbox="success"
        />
      ),
    },
    {
      width: '20%',
      style: {
        padding: '0',
        justifyContent: 'flex-start',
      },
      selector: (row) => (
        <div className="d-flex align-items-center" style={{ gap: '10px' }}>
          <ButtonCreate
            datas={datasCreateChild}
            lastItem={dataLastItemChild}
            position="custom_bottom_left"
            type="create_child"
            style={{ padding: '0' }}
          />
          <ButtonCreate
            datas={datasCreateChild}
            lastItem={dataLastItemChild}
            position="custom_bottom_left"
            type="create_child"
            style={{ padding: '0' }}
          />
          <ButtonCreate
            datas={datasOption}
            lastItem={dataLastItemOpotion}
            position="custom_top_right"
            type="option"
          />
        </div>
      ),
    },
  ];

  const handleTarget = (data) => {
    setValueStructure(data.label);
    setDataFilter([]);
  };

  const handleSearch = (e) => {
    const keyword = e.target.value?.toLowerCase();
    if (keyword !== '') {
      const filter = listStructure?.filter((val) => val.label?.toLowerCase()?.includes(keyword));
      if (filter.length === 0) {
        setDataFilter([{ id: 1, label: 'Data Tidak Ditemukan' }]);
      } else {
        setDataFilter(filter);
      }
    } else {
      setDataFilter([]);
    }
  };

  const debounceHandler = useCallback(_debounce(handleSearch, 300), []);
  return (
    <div id="test_page" className="p-2">
      <h1 className="">React - Window</h1>
      <div style={{ position: 'relative', width: '360px' }}>
        <Input
          type="search"
          name="search_structure"
          placeholder="Find Structure"
          value={valueStructure}
          onChange={(e) => {
            debounceHandler(e);
            setValueStructure(e.target.value);
          }}
        />
        <Window
          data={dataFilter}
          width={360}
          height={180}
          handleTarget={handleTarget}
        />
      </div>
      <h1 style={{ marginTop: '300px' }}>Molecule Modal List Create - CVC</h1>
      <div>
        <ButtonCreate
          datas={datasCreate}
          lastItem={dataLastItem}
          style={{ marginLeft: 'auto' }}
          position="custom_bottom_right"
          type="create"
          setModal={setModal}
          setTypeModal={setTypeModal}
        />
        <ModalCreate setModal={setModal} typeModal={typeModal} modal={modal} />
      </div>
      <h1 className="mt-5">Molecule Button Action - create</h1>
      <ButtonCreate
        datas={datasCreate}
        lastItem={dataLastItem}
        style={{ marginLeft: 'auto' }}
        position="custom_bottom_right"
        type="create"
      />
      <ButtonCreate
        datas={datasCreateChild}
        lastItem={dataLastItemChild}
        style={{ width: '48px' }}
        position="custom_bottom_left"
        type="create_child"
        styleOption="width140px"
      />
      <ButtonCreate
        datas={datasOption}
        lastItem={dataLastItemOpotion}
        style={{ width: '48px', marginTop: '2`0px', margin: 'auto' }}
        position="custom_top_right"
        type="option"
        styleOption="width140px"
      />
      <ButtonCreate
        datas={datasExport}
        lastItem={dataLastItemExport}
        style={{ width: '48px', marginTop: '10px', margin: 'auto' }}
        position="custom_center"
        type="export"
        styleOption="width140px"
      />
      <h1 className="mt-5">Molecule Input Search</h1>
      <InputSearch
        name="filter_competency"
        placeholder="Choose Competency"
        datas={dataSearch}
        setValue={setValue}
        value={value}
        choose={choose}
        setChoose={setChoose}
      />
      <h1 className="mt-5">Molecule List CVC</h1>
      <ListCvc data={datalListCvc} />
      <h1 className="mt-5">Molecule List Bisnis Process</h1>
      <List data={dataListDelete} style={{ width: '360px' }} type="delete" />
      <List data={dataListCreate} type="createBp" />
      <List data={dataListCreate} type="deleteBp" />
      <h1 className="mt-5">List Icon</h1>
      <div style={{ display: 'flex', gap: '20px' }}>
        <IconCustom typeIcon="plus" />
        <IconCustom typeIcon="plus" style={{ color: '#79FF39' }} />
        <IconCustom typeIcon="plus" style={{ color: '#6C757D' }} />
        <IconCustom typeIcon="minus" style={{ color: '#FF0000' }} />
        <IconCustom typeIcon="grid" />
        <IconCustom typeIcon="briefCase" />
        <IconCustom typeIcon="box" />
        <IconCustom typeIcon="boookmark" />
        <IconCustom typeIcon="clipboard" />
        <IconCustom typeIcon="server" />
        <IconCustom typeIcon="cat" style={{ width: '20px' }} />
        <IconCustom
          typeIcon="trash"
          style={{ width: '20px', backgroundColor: '#6C757D' }}
        />
        <IconCustom
          typeIcon="setting"
          style={{ width: '20px', height: '20px' }}
        />
        <IconCustom typeIcon="option" />
        <IconCustom typeIcon="down" />
        <IconCustom typeIcon="edit" />
        <IconCustom typeIcon="rightDown" />
        <IconCustom typeIcon="leftUp" />
        <IconCustom typeIcon="plusSquare" />
        <IconCustom typeIcon="menu" />
        <IconCustom typeIcon="copy" />
        <IconCustom typeIcon="eye" />
        <IconCustom typeIcon="move" />
        <IconCustom typeIcon="plusSquare" />
        <IconCustom typeIcon="ChevronsUp" />
        <IconCustom typeIcon="ChevronsDown" />
        <IconCustom typeIcon="ChevronsRight" />
        <IconCustom typeIcon="export" />
        <IconCustom typeIcon="import" />
        <IconCustom typeIcon="delete" />
        <IconCustom typeIcon="library" style={{ width: '16px' }} />
        <IconCustom typeIcon="loading" />
      </div>
      <h1 className="mt-5">Button</h1>
      <div className="layout_custom">
        <Button icon="create">Add</Button>
        <Button>Save</Button>
        <Button style={{ backgroundColor: '#FFFF', color: '#3D5AFE' }}>
          Cancel
        </Button>
        <Button
          icon="prefill"
          style={{ backgroundColor: 'rgba(0,0,0,0)', color: '#3D5AFE' }}
        >
          <span className="ml-3">Prefill Data</span>
        </Button>
        <Button
          style={{
            width: '28px',
            height: '28px',
            backgroundColor: 'whitesmoke',
            color: '#3D5AFE',
          }}
        >
          <IconCustom typeIcon="minus" style={{ color: '#FF0000' }} />
        </Button>
        <Button
          style={{
            width: '28px',
            height: '28px',
            backgroundColor: 'whitesmoke',
            color: '#3D5AFE',
          }}
        >
          <IconCustom typeIcon="menu" style={{ color: '#D1D1D1' }} />
        </Button>
        <Button
          style={{ backgroundColor: '#FE493D', width: '28px', height: '28px' }}
          icon="delete"
        />
        <Button style={{ width: '28px', height: '28px' }} icon="create" />
        <Button
          style={{
            width: '28px',
            height: '28px',
            backgroundColor: 'rgba(0,0,0,0)',
          }}
          icon="setting"
        />
        <Button
          style={{
            backgroundColor: 'rgba(0,0,0,0)',
            padding: '0',
            width: '28px',
          }}
          icon="3dots"
        />
      </div>
      <h1 className="mt-5">Button Label</h1>
      <div className="layout_custom">
        <Button style={{ backgroundColor: '#2E9CFF' }}>Primary</Button>
        <Button style={{ backgroundColor: '#79FF39' }}>Steering</Button>
        <Button style={{ backgroundColor: '#FFDF32' }}>Support</Button>
      </div>
      <h1 className="mt-5">Breadcrumb</h1>
      <div className="layout_custom">
        <Breadcrumb page="Test Page" />
      </div>
      <h1 className="mt-5">Input Filed</h1>
      <h3>Input Checkbox</h3>
      <div className="d-flex" style={{ gap: '20px' }}>
        <Input
          type="checkbox"
          name="input_checkbox"
          checked={isCheck}
          onChange={handleCheckbox}
          typeCheckbox="success"
          style={{ width: '100px' }}
        />
        <Input
          type="checkbox"
          name="input_checkbox"
          checked={isCheck}
          onChange={handleCheckbox}
          typeCheckbox="error"
          style={{ width: '100px' }}
        />
        <Input
          type="checkbox"
          name="input_checkbox"
          checked={isCheck}
          onChange={handleCheckbox}
          typeCheckbox="success"
        />
        <Input
          type="checkbox"
          name="input_checkbox"
          checked={isCheck}
          onChange={handleCheckbox}
          typeCheckbox="error"
        />
      </div>
      <h1 className="mt-5">Container Page</h1>
      <div className="w-100 p-4">
        <ContainerPage style={{ height: '30vh' }}>
          <Label className="mb-4" typeLabel="label_table">
            Top Level View
          </Label>
          <ListCvc data={datalListCvc} />
        </ContainerPage>
      </div>
      <h1 className="mt-5">Table</h1>
      <div className="w-100 p-4">
        <ContainerPage style={{ height: '40em' }}>
          <Label className="mb-4" typeLabel="label_table">
            Top Level View
          </Label>
          <CustomTable
            columns={columns}
            data={dataTable}
            filter="tree_view"
            pagination
            customStyles={{
              table: {
                style: {
                  height: '100%',
                  overflow: 'auto',
                  justifyContent: 'space-between',
                  '&::-webkit-scrollbar': {
                    width: '4px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                    borderRadius: '10px',
                  },
                  '&::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: '#444444',
                  },
                  '&::-webkit-scrollbar-track': {
                    WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.1)',
                    borderRadius: '10px',
                  },
                },
              },
              headCells: {
                style: {
                  fontFamily: 'sans-serif',
                  justifyContent: 'space-between !important',
                  whiteSpace: 'pre-wrap',
                  // backgroundColor: "blue"
                },
              },
              subHeader: {
                style: {
                  display: 'none',
                },
              },
            }}
          />
        </ContainerPage>
      </div>
      <h3 className="mt-2">Input Text</h3>
      <div className="layout_custom">
        <Input
          type="text"
          name="input_process_name"
          placeholder="Process Name"
        // style={{ maxWidth: "350px" }}
        />
        <Input
          type="text"
          name="input_competency_type"
          placeholder="Insert Competency Type"
          style={{ maxWidth: '350px' }}
          placeholderPosition="start"
        />
      </div>
      <div className="layout_custom mt-2">
        <Input
          type="text"
          name="input_activity"
          placeholder="Activity"
          placeholderPosition="start"
        />
      </div>
      <h3 className="mt-2">Input Search</h3>
      <div className="layout_custom mt-2">
        <Input
          type="search"
          name="input_choose_set"
          placeholder="Choose Set"
        // style={{ maxWidth: "400px" }}
        />
        <Input
          type="search"
          name="input_choose_level"
          placeholder="Choose Level"
          style={{ maxWidth: '400px' }}
        />
      </div>
      <h3 className="mt-2">Input Number</h3>
      <div className="layout_custom">
        <Input
          type="number"
          name="input_activity"
          placeholder="Insert Competency Level"
          placeholderPosition="start"
        />
        <Input
          type="number"
          name="input_standart_time"
          placeholder="Standart Time"
          placeholderPosition="start"
          style={{ maxWidth: '180px' }}
        />
      </div>
      <h1 className="mt-5">Text Area</h1>
      <div className="layout_custom">
        <TextArea
          name="text_area_activity"
          placeholder="Masukkan Isi Aktivitas Anda"
        />
      </div>
      <div className="layout_custom mt-2">
        <TextArea
          name="text_area_activity"
          placeholder="Masukkan Isi Aktivitas Anda"
          style={{ height: '160px' }}
        />
        <TextArea
          name="text_area_activity"
          placeholder="Masukkan Isi Aktivitas Anda"
          style={{ width: '260px', height: '120px' }}
        />
      </div>
      <h1 className="mt-5">Text Editor</h1>
      <div className="layout_custom">
        <TextEditor
          name="text_editor_input"
          placeholder="Insert Your Input"
        />
        <TextEditor
          name="text_editor_input"
          placeholder="Insert Your Input"
          style={{ width: '380px', height: '15em' }}
        />
      </div>
      <h1 className="mt-5">Tab Field</h1>
      <Tab />
      <Tab
        data={[
          {
            id: 1,
            name: 'Library',
          },
          {
            id: 2,
            name: 'Manual',
          },
        ]}
        typeTab="button"
      />
      <h1 className="mt-5">List Labels</h1>
      <Label typeLabel="label_page">Chompany Value Chain</Label>
      <Label typeLabel="label_table">Top Level View</Label>
      <Label>Procurement Activities</Label>
      <Label typeLabel="label_option" style={{ textAlign: 'right' }}>
        Add Primary Process
      </Label>
      <Label typeLabel="label_option" style={{ textAlign: 'right' }}>
        Add Support Process
      </Label>
      <Label typeLabel="label_modal" style={{ textAlign: 'center' }}>
        Add Bussiness Process
      </Label>
      <Label typeLabel="label_modal2" style={{ textAlign: 'center' }}>
        Primary
      </Label>
      <h3>List Label Custom</h3>
      <Label
        style={{
          fontSize: '14px',
          fontWeight: '800',
          color: '#4F4F4F',
        }}
      >
        Level Description
      </Label>
      <Label
        style={{
          fontSize: '14px',
          fontWeight: '500',
          color: '#4F4F4F',
        }}
      >
        You haven't select any competency and level
      </Label>
      <div className="d-flex align-items-center">
        <IconCustom typeIcon="plus" style={{ color: '#6C757D' }} />
        <Label
          style={{
            fontSize: '12px',
            fontWeight: '500',
            color: '#4F4F4F',
          }}
        >
          Total Activity
        </Label>
      </div>
      <Label
        style={{
          fontSize: '24px',
          fontWeight: '800',
          color: '#4F4F4F',
          textAlign: 'center',
          lineHeight: '36px',
        }}
      >
        999
      </Label>
      <Label
        style={{
          fontSize: '12px',
          fontWeight: '500',
          color: '#4F4F4F',
          textAlign: 'center',
        }}
      >
        Total Activity
      </Label>

      <TextAreaAutoResizeCustom
        className="form-control "
        value={textArea}
        placeholder="Text Area"
        onChange={(e) => {
          setTextArea(e.target.value);
        }}
      />
    </div>
  );
}

export default TestPage;
